import * as Actions from '../actions/forgotpassword.actions';
import * as Constants from '../actions/forgotpassword.constants';
import { ForgotPasswordState } from '../types/forgotpassword-state';

const defaultState: Partial<ForgotPasswordState> = {
  loading: false
};

export function reducer(state: Partial<ForgotPasswordState> = defaultState, action: Actions.All)
  : Partial<ForgotPasswordState> {

  switch (action.type) {

    case Constants.RESET: {
      return { ...defaultState };
    }

    case Constants.SET_USER_DETAILS: {
      const { type, ...details } = action as Actions.SetUserDetailsAction;
      return { ...state, ...details };
    }

    case Constants.SET_VERIFICATION_DETAILS: {
      const { type, ...details } = action as Actions.SetVerificationDetailsAction;
      return { ...state, ...details, loading: false };
    }

    case Constants.SET_ERROR_MESSAGE: {
      const { message } = action as Actions.SetErrorMessageAction;
      return { ...state, message, loading: false };
    }

    default:
      return state;
  }
}